export const isDeliverySurchargeAddon = (id: string | undefined): boolean => {
    return !!id?.includes('_delivery_surcharge');
};
